import { isTag, isElementNode } from 'anodum';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import { IMAGE_TAG } from '../constants/editable-elements';

const isElementRequireRootPosition = (element, rootElement) => {
  if (!isElementNode(element)) return false;

  if (
    isTag(element, IMAGE_SELECTOR) ||
    (isTag(element, IMAGE_TAG) && !element.closest(IMAGE_SELECTOR))
  ) {
    return element.parentNode !== rootElement;
  }

  return false;
};

export default isElementRequireRootPosition;
